import { API, Endpoints } from '@brg/api';
import { useToasts } from '@brg/ui';
import { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useRouteMatch } from 'react-router-dom';
import { LinkTo } from 'shared/constants/linkTo';

export const useToggleBilingual = (
   item: { isBilingual?: boolean, teamId?: string, projectId?: string, competitionId?: string } | undefined,
   onUpdate?: (n: number) => void
  ) => {
    const toasts = useToasts();
    const { t } = useTranslation();

    const isBilingual = useMemo(() => (!!item?.isBilingual), [item]);
    const isTeam = useMemo(() => (!!item?.teamId), [item]);
    const isCompetitionEdit = useRouteMatch(LinkTo.competitionEdit)
    const id = useMemo(() => item?.teamId || item?.projectId || item?.competitionId, [item]);

    const onToggleBilingual = useCallback(() => {
        const confirmation = window.confirm(!!isBilingual ? t('teams.adminPage.toasts.disable_bilingual') : t('teams.adminPage.toasts.make_bilingual'));
        if (!!id && confirmation) {

            if (isCompetitionEdit) {
              API.request()
              .endpoint(Endpoints.competitions)
              .url(`/api/competition/${!isBilingual ? 'MakeBilingual' : 'DisableBilingual'}`)
              .post()
              .addQuery(`competitionId`, id)
              .release()
              .then((res) => {
                if (res?.ErrorMessage) {
                  toasts.error(t('teams.adminPage.errors.bilingual_fail'))
                }
        
                onUpdate && onUpdate(Date.now())
              });
  
              return;
            } 

            API.request()
            .endpoint(Endpoints.geograffee)
            .url(`/api/${isTeam ? 'Team' : 'Project'}/${!isBilingual ? 'MakeBilingual' : 'DisableBilingual'}`)
            .get()
            .addQuery(`${isTeam ? 'teamId' : 'projectId'}`, id)
            .release()
            .then((res) => {
              if (res?.ErrorMessage) {
                toasts.error(t('teams.adminPage.errors.bilingual_fail'))
              }
      
              onUpdate && onUpdate(Date.now())
            });


        }
      }, [id, t, toasts, isBilingual, isTeam, onUpdate, isCompetitionEdit])

    return [onToggleBilingual];
}import { API, Endpoints } from '@brg/api';
import { useToasts } from '@brg/ui';
import { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useRouteMatch } from 'react-router-dom';
import { LinkTo } from 'shared/constants/linkTo';

export const useToggleBilingual = (
   item: { isBilingual?: boolean, teamId?: string, projectId?: string, competitionId?: string } | undefined,
   onUpdate?: (n: number) => void
  ) => {
    const toasts = useToasts();
    const { t } = useTranslation();

    const isBilingual = useMemo(() => (!!item?.isBilingual), [item]);
    const isTeam = useMemo(() => (!!item?.teamId), [item]);
    const isCompetitionEdit = useRouteMatch(LinkTo.competitionEdit)
    const id = useMemo(() => item?.teamId || item?.projectId || item?.competitionId, [item]);

    const onToggleBilingual = useCallback(() => {
        const confirmation = window.confirm(!!isBilingual ? t('teams.adminPage.toasts.disable_bilingual') : t('teams.adminPage.toasts.make_bilingual'));
        if (!!id && confirmation) {

            if (isCompetitionEdit) {
              API.request()
              .endpoint(Endpoints.competitions)
              .url(`/api/competition/${!isBilingual ? 'MakeBilingual' : 'DisableBilingual'}`)
              .post()
              .addQuery(`competitionId`, id)
              .release()
              .then((res) => {
                if (res?.ErrorMessage) {
                  toasts.error(t('teams.adminPage.errors.bilingual_fail'))
                }
        
                onUpdate && onUpdate(Date.now())
              });
  
              return;
            } 

            API.request()
            .endpoint(Endpoints.geograffee)
            .url(`/api/${isTeam ? 'Team' : 'Project'}/${!isBilingual ? 'MakeBilingual' : 'DisableBilingual'}`)
            .get()
            .addQuery(`${isTeam ? 'teamId' : 'projectId'}`, id)
            .release()
            .then((res) => {
              if (res?.ErrorMessage) {
                toasts.error(t('teams.adminPage.errors.bilingual_fail'))
              }
      
              onUpdate && onUpdate(Date.now())
            });


        }
      }, [id, t, toasts, isBilingual, isTeam, onUpdate, isCompetitionEdit])

    return [onToggleBilingual];
}